import React from 'react';

export const RacingIcon = () => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.3 6.01895L9.75 6.46748C10.5 7.14025 9.375 8.26154 8.7 7.51401L8.325 7.14025C7.5 6.39272 8.625 5.27145 9.3 6.01895Z"
            fill="#136A4D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 0.786321L0 3.7764V14.9892L4.875 9.00905C5.625 9.75658 6.375 10.5041 6.75 11.2516C6.87538 11.5015 6.87852 11.9719 6.88203 12.4974C6.88902 13.5437 6.89748 14.8088 7.875 14.9892C7.875 14.9892 8.33312 15.0135 8.625 14.9892L12.75 13.4942V5.27145L15 3.02888V1.53384L7.3125 1.53384C7.3125 1.53384 7.125 0.711568 6.375 0.337808C5.625 -0.0359527 4.5 -0.334961 3 0.786321ZM6.375 3.02888C6.375 3.02888 6.375 2.65512 6 2.28136C5.73809 2.02031 5.11033 1.86866 4.5 1.97921V4.52393C4.5 5.64521 3 5.64521 3 4.52393V3.02889L1.5 4.52392V10.5041L4.875 6.76649L8.25 10.8779V13.4942L11.25 12.3729V4.52392L12.75 3.02888H6.375Z"
            fill="#136A4D"
        />
    </svg>
);

export default RacingIcon;
